import React from 'react'
import { storiesOf } from '@storybook/react'
import { action } from '@storybook/addon-actions'

import QuizIntro from 'components/GameCard/components/QuizIntro'

storiesOf('GameCard/QuizIntro', module)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#EEE' }}>{story()}</div>
      <div style={{ padding: 32, backgroundColor: '#EEE', width: 320, borderTop: '1px solid #AAA' }}>{story()}</div>
    </>
  ))
  .add('default', () => (
    <QuizIntro
      onClose={action('onClose')}
      homeTeam="Bayern München"
      awayTeam="Manchester United"
    />
  ))
